import React from 'react';
import { Button } from '../ui/Button';
import { motion } from 'framer-motion';
import { Flower2 } from 'lucide-react';
export function FinalCTA() {
  return <section id="purchase-section" className="relative overflow-hidden text-center py-24 md:py-32 px-4 sm:px-6 lg:px-8" data-id="element-104">
      {/* Dreamy Background */}
      <div className="absolute inset-0 z-0" data-id="element-105">
        <img src="https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=1600&q=60" alt="" className="w-full h-full object-cover blur-xl scale-110 opacity-30" aria-hidden="true" data-id="element-106" />
        <div className="absolute inset-0 bg-gradient-to-b from-blush/90 via-cream/85 to-cream/95" data-id="element-107" />
      </div>

      {/* Decorative blurs */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-dusty-rose/15 rounded-full blur-3xl pointer-events-none" data-id="element-108" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-warm-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-109" />

      <div className="relative z-10 max-w-4xl mx-auto" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} viewport={{
        once: true
      }} data-id="element-111">
          {/* Decorative divider */}
          <div className="mb-10 flex items-center justify-center gap-3" data-id="element-112">
            <div className="w-16 h-px bg-warm-gold/40" data-id="element-113" />
            <Flower2 className="w-6 h-6 text-warm-gold/60" strokeWidth={1.5} data-id="element-114" />
            <div className="w-16 h-px bg-warm-gold/40" data-id="element-115" />
          </div>

          <h2 className="text-4xl md:text-6xl font-serif italic text-navy mb-10" data-id="element-116">
            ¿Lista para dejar de vivir agotada?
          </h2>

          <div className="text-lg md:text-xl text-muted font-light mb-14 space-y-6 max-w-2xl mx-auto leading-relaxed" data-id="element-117">
            <p data-id="element-118">
              Hoy, por tiempo limitado, llevate el Pack Premium completo del
              Método Energía Real por solo{' '}
              <strong className="font-serif italic text-warm-gold text-2xl font-medium" data-id="element-119">
                $12.999 ARS
              </strong>
              .
            </p>
            <p data-id="element-120">
              Esta oferta es por tiempo limitado y puede volver al precio
              original en cualquier momento.
            </p>
            <p data-id="element-121">Accedé ahora y empezá a sentir más alivio en una semana.</p>
          </div>

          <Button href="https://checkout.infinita-mente.online/checkouts/cn/hWN9k9IdvMh4a0eyG3Ib72tF/es-ar?_r=AQABuGfEX37MTkCup0Rq8tDOnVM70xe0iNj_Nsvx1rNaHiU&preview_theme_id=138558668898" external variant="vibrant" size="xxl" className="w-full sm:w-auto mb-6" data-id="element-122">
            OBTENER MI MÉTODO ENERGÍA REAL AHORA
          </Button>

          <p className="text-sm font-light text-muted mb-12 italic" data-id="element-123">
            (Pago único, seguro y con garantía de 7 días)
          </p>

          <div className="flex justify-center gap-4 opacity-70 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-124">
            <div className="h-10 px-4 bg-cream/80 backdrop-blur-sm rounded-full border border-dusty-rose/30 flex items-center text-xs font-bold text-navy tracking-widest" data-id="element-125">
              VISA
            </div>
            <div className="h-10 px-4 bg-cream/80 backdrop-blur-sm rounded-full border border-dusty-rose/30 flex items-center text-xs font-bold text-navy tracking-widest" data-id="element-126">
              MASTERCARD
            </div>
            <div className="h-10 px-4 bg-cream/80 backdrop-blur-sm rounded-full border border-dusty-rose/30 flex items-center text-xs font-bold text-navy tracking-widest" data-id="element-127">
              MERCADO PAGO
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}